<template>
  <div id="app">
    <el-container>
<!--      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">-->
<!--      公司介绍-->
      <el-main>
        <div class="main-title">
              <span v-if="infozhi.auth_info.type===1">个人介绍</span>
            <span v-else>企业介绍</span>
        </div>
          <div >
        <div class="main-title-background">
          <div class="main-title-phone">{{infozhi.shop_desc}}</div>
        </div>
        </div>
      </el-main>
    </el-container>
    <el-container>
      <el-main>
        <!--        联系我们-->
        <div v-if="infozhi.contact_phone !== ''">
          <div class="main-title3">联系我们</div>
          <div class="main-title-background3">
            <div class="main-title-phone">联系人：{{infozhi.auth_info.contact_name}}</div>
            <div class="main-title-phone">联系电话：{{infozhi.auth_info.contact_phone}}</div>
<!--            <div class="main-title-phone">联系地址：{{infozhi.auth_info.address}}</div>-->
              <div class="main-title-phone">联系地址：{{infozhi.auth_info.contact_addr}}</div>
            <div class="main-title-phone">网站地址：{{infozhi.auth_info.website}}</div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>

export default {
  name: "category",
  data: function () {

    return {
      url:'',
      input:'',
      searchValue:'',
      id:'',
      infozhi:'',
      lianxizhi:'',
      catezhi:'',
        auth_type:'',
    }
  },
  methods: {
    init(){
      var t = this
      this.information = this.$store.state.information
      t.id = t.$route.params.id
      if (t.$store.state.shopsSearchValue){
        t.searchValue = t.$store.state.shopsSearchValue
      }
      if (t.searchValue){
        t.input = t.searchValue
      }
      this.list_data()
      this.url = window.config.api_url
      // this.list_lainxi()
      // this.dp_inform()
    },
    input_sj(e){
      var t = this
      t.input = e
      t.list_data()
    },
    list_data(){
      var t = this
      var url = window.config.api_url+'/college/shop/info?id='+t.id
      if (t.input){
        url += '&keywords='+t.input
      }
      t.axios.get(url).then(res=>{
        t.infozhi = res.data
          console.log(res.data)
      })
    },
    fujiaxz(e){
      this.$router.push(this.url+'/storage/'+e);
    },
    handleChange2(e){
      this.$store.commit('savePath',e)

    }
  },

  created() {
    this.init()
  }
}

</script>

<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
@head_text : Source Han Sans CN;
@font-face {

}
//@import "../../../assets/css/home";
@import "../../../assets/css/shops_companyData";
</style>
<style lang="less" scoped>
@font-face {

}
</style>